// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2-uA_","description":"PatientConsentPreview_description__JrGRv"};